module.exports = __webpack_public_path__ + "img/5.273b1c7b.png";